// extracted by mini-css-extract-plugin
export var carrierIcon = "_we-0";
export var carrierLogo = "_we-1";
export var detailsSection = "_we-2";